import React from "react";

const ItemPage = () => {
  return <div>ItemPage</div>;
};

export { ItemPage };
